import { Handle, Position } from '@xyflow/react';

import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';

import { InformationIcon } from '../informationIcon';
import * as s from './styles/flowNode.module.scss';
import type { IFlowNodeProps } from './types';

export const MockFlowNode = ({ data: { icon, title } }: IFlowNodeProps) => (
  <div className={generateClassName(['flow-node', s.flowNode, s.flowNodeSmall])}>
    {title && (
      <div className={s.flowNodeTitleWrapper}>
        {icon && <Icon iconName={icon}  fillColor='currentColor'/>}
        <span className={s.flowNodeTitle}>{title}</span>
      </div>
    )}
  </div>
);

export const FlowNode = ({ data: { icon, title, text, hasMenu, type, showInformation = false } }: IFlowNodeProps) => {

  if (type) {
    return (
      <div className={generateClassName([s.flowNodeBadge, s[type as keyof typeof s]])}>
        <div className={s.flowNodeSubtext}>{text}</div>
        <Handle type="source" position={Position.Bottom} />
        <Handle type="target" position={Position.Top} />
      </div>
    );
  }

  return (
    <div className={generateClassName([s.flowNode, text ? s.flowNodeLarge : s.flowNodeSmall])}>
      {title && (
        <div className={s.flowNodeTitleWrapper}>
          {icon && <Icon iconName={icon}  fillColor='currentColor'/>}
          <span className={s.flowNodeTitle}>{title}</span>
          {hasMenu && <Icon iconName="MenuDotsOutline"  fillColor='currentColor'/>}
        </div>
      )}
      {showInformation && <InformationIcon className={s.informationIcon} />}
      {text && <div className={s.flowNodeSubtext}>{text}</div>}
      <Handle type="source" position={Position.Bottom} />
      <Handle type="target" position={Position.Top} />
    </div>
  );
};
